import { render, staticRenderFns } from "./head.vue?vue&type=template&id=419aa1aa"
import script from "./head.vue?vue&type=script&lang=js"
export * from "./head.vue?vue&type=script&lang=js"
import style0 from "~/assets/css/common/head.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "~/assets/arabCSS/common/head.scss?vue&type=style&index=1&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LoginBox: require('/src/components/login/loginBox.vue').default})
